export default "__VITE_ASSET__DmOumiY5__"